import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { Router } from '@angular/router';
import { Subject, takeUntil } from 'rxjs';
import { ReRegisterKkmFields } from '../../kkm-operations/re-register-kkm/re-register-kkm.model';
import { RetailPlacesApiService } from '../../../../core/modules/retail-places/retail-places-api.service';

@Component({
  selector: 'tax-kkm-rereg-form',
  templateUrl: './kkm-rereg-form.component.html',
  styleUrls: ['./kkm-rereg-form.component.sass'],
})

export class KkmReRegFormComponent implements OnInit, OnDestroy {
  // @ts-ignore
  @Input() kkmForm: ReRegisterKkmFields;

  @Output() continueProcess: EventEmitter<ReRegisterKkmFields> = new EventEmitter<ReRegisterKkmFields>();

  retailPlaces: any[] = [];
  isConfirmed = true;

  private destroy$: Subject<void> = new Subject<void>();

  constructor(
    private router: Router,
    private retailPlacesApiService: RetailPlacesApiService,
  ) {}

  ngOnInit(): void {
    this.retailPlacesApiService.fetchRetailPlaces()
      .pipe(takeUntil(this.destroy$))
      .subscribe(response => this.retailPlaces = response);
  }

  // @ts-ignore
  selectedRetailPlace(retailPlace): void {
    [this.kkmForm.retailPlaceId, this.kkmForm.retailPlaceTitle] = [retailPlace.id, retailPlace.title];
  }

  isFormValid(): boolean {
    // @ts-ignore
    return this.kkmForm.kkmInternalName
      && this.kkmForm.kkmModel
      && this.kkmForm.kkmSerialNumber
      && this.kkmForm.kkmYear
      && this.kkmForm.retailPlaceId
      && this.isConfirmed;
  }

  continue(): void {
    this.continueProcess.emit(this.kkmForm);
  }

  back(): void {
    this.router.navigate([`main/kkms/${this.kkmForm.kkmId}/settings`]);
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.unsubscribe();
  }
}
